import { isDevelopment } from '../constants';

export const logger = (message: string, data: any) => {
  if (isDevelopment) {
    console.log(message, data);
  }
};
